export const COMPANY_BASE_SEARCH = [
  { title: "companyName", value: "companyInformation.companyName" },
  { title: "phoneNumber", value: "phoneNumber" },
  { title: "firstName", value: "firstName" },
  { title: "lastName", value: "lastName" },
  { title: "nationalCode", value: "nationalCode" },
];
export const COMPANY_BASE_SEARCH_SUPERAGENT_ROLE = [
  { title: "companyName", value: "COMPANY_NAME" },
  { title: "phoneNumber", value: "PHONE_NUMBER" },
  { title: "firstName", value: "FIRST_NAME" },
  { title: "lastName", value: "LAST_NAME" },
  { title: "nationalCode", value: "NATIONAL_CODE" },
];

export const SUPER_AGENT_BASE_SEARCH = [
  { title: "phoneNumber", value: "phoneNumber" },
  { title: "firstName", value: "firstName" },
  { title: "lastName", value: "lastName" },
];
export const GOVRNMENTSHIP_BASE_SEARCH = [
  // { title: "firstName", value: "firstName" },
  // { title: "firstName", value: "governmentShipInformation.name" },
  { title: "phoneNumber", value: "phoneNumber" },
];
export const SUPER_AGENT_PROVINCE_BASE_SEARCH = [
  { title: "firstName", value: "firstName" },
  { title: "firstName", value: "provinceEducationInformation.name" },
  { title: "phoneNumber", value: "phoneNumber" },
];

export const SCHOOL_BASE_SEARCH = [
  { title: "schoolName", value: "name" },
  { title: "telephone", value: "telephone" },
  { title: "schoolManagerName", value: "fullName" },
  { title: "schoolManagerPhoneNumber", value: "phoneNumber" },
];

export const DRIVER_BASE_SEARCH = [
  { title: "firstName", value: "firstName" },
  { title: "lastName", value: "lastName" },
  { title: "nationalCode", value: "driverInformation.nationalCode" },
  { title: "phoneNumber", value: "phoneNumber" },
  { title: "tagNumber", value: "tagNumber" },
];
export const DRIVER_BASE_SEARCH_SUPERAGENT = [
  { title: "firstName", value: "FIRST_NAME" },
  { title: "lastName", value: "LAST_NAME" },
  { title: "nationalCode", value: "NATIONAL_CODE" },
  { title: "phoneNumber", value: "PHONE_NUMBER" },
];

export const SERVICE_BASE_SEARCH = [
  { title: "firstName", value: "student.firstName" },
  { title: "lastName", value: "student.lastName" },
  { title: "nationalCode", value: "student.nationalCode" },
];

export const PARENT_BASE_SEARCH = [
  { title: "phoneNumber", value: "phoneNumber" },
  { title: "firstName", value: "firstName" },
  { title: "lastName", value: "lastName" },
];
export const PARENT_BASE_SEARCH_SUPERAGENT = [
  { title: "phoneNumber", value: "PHONE_NUMBER" },
  { title: "firstName", value: "FIRST_NAME" },
  { title: "lastName", value: "LAST_NAME" },
];

export const TRANSACTION_BASE_SEARCH = [
  { title: "description", value: "description" },
];

export const LOCATION_PROVINCE_BASE_SEARCH = [
  { title: "name", value: "name" },
];

export const TRANSACTION_BASE_SEARCH_2 = [
  { title: 'firstName'  , value: 'firstName'             },
  { title: 'lastName'   , value: 'lastName'              },
  { title: 'phoneNumber', value: 'phoneNumber'           },
  { title: 'kartNumber' , value: 'financial.kartNumber'  },
  { title: 'shabaNumber', value: 'financial.shabaNumber' },
];


export const MUNICIPALITY_BASE_SEARCH = [
  { title: "phoneNumber", value: "phoneNumber" },
  { title: "municipalityName", value: "municipalityInformation.name" },
];
export const TICKET_BASE_SEARCH = [
  { title: "trackingCode", value: "trackingCode" },
];
